var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scroll-pane" }, [
    _c("div", { staticClass: "header" }, [_vm._t("header")], 2),
    _c(
      "div",
      { staticClass: "scroll" },
      [_vm.defer(2) ? _vm._t("scroll") : _vm._e()],
      2
    ),
    _vm.$slots.footer
      ? _c("div", { staticClass: "footer" }, [_vm._t("footer")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }